module.exports = __webpack_public_path__ + "static/media/automotive.2c155cf6.svg";